import { useMemo } from 'react'
import styled from 'styled-components'
import { AppModal } from '../../../../../generic/ui/Modal'
import { GridTable, TableSummary, TableToolbar } from '../../../../../generic/grid-table'
import useExportToExcel from '../../../../../generic/hooks/useExportToExcel'
import columnsToExcel from '../../../../../generic/universal-table/utils/columnsToExcel'
import type { IReceiptReportLine } from '../../../../../modules/API/Reciept/models/receipt'
import ReceiptsReportFilterForm from './Components/ReceiptsReportFilterForm'
import { useReceiptsReport } from './hooks/useReceiptsReport'
import { buildReceiptsReportColumns } from './configs/receiptsReport.columns'
import { buildReceiptsReportSummaryItems } from './configs/receiptsReport.summary'

const columns = buildReceiptsReportColumns()
const excelColumns = columnsToExcel(columns)
// 10 summary cells — two even rows of 5.
const SUMMARY_COLUMNS = 5

const ReceiptsReportMain = () => {
  const {
    lines,
    rows,
    totalCount,
    hasData,
    isLoading,
    stats,
    appliedFilters,
    searchQuery,
    handleSearch,
    isFilterOpen,
    toggleFilter,
    filterFormProps,
  } = useReceiptsReport()

  const { handleExport } = useExportToExcel({ columns: excelColumns, fileName: 'receipt-lines', rtl: true })

  const summaryItems = useMemo(
    () => buildReceiptsReportSummaryItems(stats, appliedFilters),
    [stats, appliedFilters],
  )

  return (
    <TableSection>
      {isFilterOpen && (
        <AppModal
          title='שאילתת שורות קבלה'
          Children={ReceiptsReportFilterForm}
          childrenProps={filterFormProps}
          controlFunc={toggleFilter}
          size='sm'
        />
      )}
      <GridTable<IReceiptReportLine>
        title='שאילתת שורות קבלה'
        count={totalCount}
        columns={columns}
        rows={rows}
        getRowId={(row) => row.RecID}
        isLoading={isLoading}
        emptyTitle={lines ? 'לא נמצאו קבלות' : 'בחר תאריכים'}
        summary={hasData ? <TableSummary items={summaryItems} columns={SUMMARY_COLUMNS} /> : undefined}
        collapsibleSummary
        toolbarActions={
          <TableToolbar
            searchValue={searchQuery}
            onSearchChange={handleSearch}
            searchPlaceholder='חיפוש…'
            onExport={() => handleExport(rows)}
            onFilter={toggleFilter}
          />
        }
      />
    </TableSection>
  )
}

export default ReceiptsReportMain

const TableSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8em;
  width: 100%;
  height: 100%;
  padding: 0.5em;
  overflow: hidden;
`
